import { Button } from 'ccs-ui-components';
import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import DATATYPE from '../DataTypesConstants';
import { Field, TypeNode, Utils } from '../Utils';
import './DataTypesList.scss';

interface DataTypesListInterface {
  field: Field,
}

export const DataTypesList = ({ field: curentField }: DataTypesListInterface) => {
  const [showArrayChild, setArrayChild] = useState(false);
  const { t: translate } = useTranslation();

  /**
   * @method getButtonClass
   * @description Returns the class name for a data type button.
   * @param dataType - The data type to check against.
   * @returns The class name for the data type button.
   */
  const getButtonClass = (dataType: string) => {
    let classNames = 'data-type-button';
    if (Utils.checkTypes(curentField.type, dataType)) {
      classNames += ' data-type-selected';
    }
    return classNames;
  };

  /**
   * @method isDataTypeSelected
   * @description Checks if a specific data type is selected.
   * @param dataType The data type to check.
   * @returns True if the data type is selected, false otherwise.
   */
  const isDataTypeSelected = (dataType: string) => (curentField.type as TypeNode).items && Utils.checkTypes((curentField.type as TypeNode).items ?? [], dataType);

  /**
   * @method getChildButtonClass
   * @description Returns the class name for the child button based on the data type.
   * @param dataType The data type to check.
   * @returns The class name for the child button.
   */
  const getChildButtonClass = (dataType: string) => {
    let classNames = 'data-type-button';

    if (Utils.checkTypes(curentField.type, 'array')) {
      if (Array.isArray(curentField.type)) {
        (curentField.type).forEach((dataTypeItem: (TypeNode | string)) => {
          if (Utils.checkTypes(dataTypeItem, 'array')) {
            if (typeof dataTypeItem === 'object' && dataTypeItem.items && Utils.checkTypes(dataTypeItem.items, dataType)) {
              classNames += ' data-type-selected';
            }
          }
        });
      } else if (isDataTypeSelected(dataType)) {
        classNames += ' data-type-selected';
      }

      return classNames;
    }
    return classNames;
  };

  useEffect(() => {
    if (Utils.checkTypes(curentField.type, 'array')) {
      setArrayChild(true);
    }
  }, []);

  return (
    <div className="datatypes-list">
      <div className="main-datatypes-list">
        <div className="datatypes-header">{translate('schemaGeneratorText.datatypeListHeader')}</div>
        {DATATYPE.map((item) => (
          <Button variant="primary" className={getButtonClass(item.dataType)} key={item.id} data-testid="btn-test-data-id">
            {item.text}
          </Button>
        ))}
      </div>
      {
        showArrayChild && (
          <div className="child-datatypes-list">
            <div className="datatypes-header">{translate('schemaGeneratorText.arrayItemsTypeHeader')}</div>
            {DATATYPE.map((item) => (
              item.dataType !== 'array' && (
                <Button variant="primary" key={`child-${item.id}`} id={`child-${item.id}`} data-testid="btn-test-arry-child-id" className={getChildButtonClass(item.dataType)}>
                  {item.text}
                </Button>)
            ))}
          </div>)
      }
    </div>
  );
};
